import { IEditorV3Line } from "./interface";

/**
 * Checks if the provided object is an instance of IEditorV3Line.
 *
 * @param obj - The object to check.
 * @returns True if the object is an IEditorV3Line, false otherwise.
 */
export const isIEditorV3Line = (obj: unknown): obj is IEditorV3Line => {
  return (
    // Check object
    typeof obj === "object" &&
    obj !== null &&
    // Check properties exist
    "textBlocks" in obj &&
    // Check properties types
    Array.isArray((obj as IEditorV3Line).textBlocks) &&
    (obj as IEditorV3Line).textBlocks.every((tb) => "text" in tb)
  );
};
